import React from 'react';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'dayjs/locale/ko';
import 'swiper/css';
import BadgeItem from './../../../Components/Ui/BadgeItem';
import Icon from '../../../Assets/Icon/CustomIcon';

export default function Notice() {
  const { navigate } = useAppNavigate();
  const { noticeData } = useSelector((state) => state.homeInfo);

  // 제목이 있는 유효한 공지사항만 필터링
  const validNoticeData =
    noticeData?.filter((item) => item.title && item.title.trim() !== '') || [];

  return (
    <div className="flex w-full flex-col gap-4">
      {/* 공지사항 컨텐츠 영역 */}
      <div className="mb-2 w-full max-w-[calc(100vw-32px)] overflow-hidden rounded-lg border border-slate-50 shadow-sm">
        {validNoticeData.length === 0 ? (
          <div
            className="w-full bg-white px-4 py-5 text-center text-[14px] text-slate-400"
            onClick={() => {
              navigate(`/M_Notice`);
            }}
          >
            등록된 공지사항이 없습니다.
          </div>
        ) : (
          <Swiper
            slidesPerView={1}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            className="w-full"
            loop
            modules={[Autoplay]}
          >
            {validNoticeData.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className="transition-active flex w-full cursor-pointer justify-between gap-2 bg-white p-3"
                  onClick={() => {
                    navigate('/M_Notice');
                  }}
                >
                  <div className="flex items-center gap-2 overflow-hidden">
                    <div className="flex shrink-0 gap-1">
                      {item?.noticeYn === 'Y' && (
                        <BadgeItem type="중요" label="중요" />
                      )}
                      <BadgeItem type={item?.gubunNm} label={item?.gubunNm} />
                    </div>
                    <p className="max-w-[85%] truncate text-xs font-medium text-slate-700">
                      {item.title}
                    </p>
                  </div>
                  <div className="text-base text-slate-300">
                    <Icon.ChevronRight />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
}
